import useEditingStore from '@hooks/useEditingStore';
import { $tourData } from '@stores/dataStores';
import {
  $GateSearchBtn,
  $editingFlag,
  $editingUIColor,
} from '@stores/editingStores';
import { TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';

function WButtonsREA() {
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI =
        getTemplateConfig(TemplateId.realEstateA)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const showShare = !!(flag?.showShareBtn ?? 1);
  const showLike = !!(flag?.showLikeBtn ?? 1);
  const showCommentBtn = !!(flag?.showCommentBtnV2 ?? 1);

  const color = `rgba(${ui.fontColor})`;

  return (
    <div className="absolute right-30 top-24 flex flex-col items-center">
      <div
        className="flex w-[36px] flex-col items-center rounded-full py-20 gap-20"
        style={{
          backgroundColor: `rgba(${ui.panelBgColor})`,
        }}
      >
        {showLike && (
          <svg width={24} height={24}>
            <defs>
              <clipPath id="prefixdgPzQRpQnM501J3349pW0a">
                <rect width="24" height="24" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixdgPzQRpQnM501J3349pW0a)">
              <path
                fill={color}
                d="M20.892 11.57c.371-.489.576-1.09.576-1.714 0-.99-.554-1.928-1.445-2.45a1.5 1.5 0 0 0-.757-.206h-5.29l.132-2.711c.031-.656-.2-1.278-.65-1.752A2.35 2.35 0 0 0 11.737 2a2.565 2.565 0 0 0-2.466 1.878l-1.895 6.861H4.524a.705.705 0 0 0-.706.706v8.03c0 .391.316.707.706.707H17.79c.203 0 .402-.04.585-.12a2.837 2.837 0 0 0 1.608-3.428 2.84 2.84 0 0 0 .457-2.53c.37-.49.576-1.09.576-1.715a3 3 0 0 0-.124-.818M5.407 18.594v-6.266h1.787v6.266zm14.04-7.788-.483.42.307.56q.152.28.152.602c0 .364-.159.71-.432.949l-.484.419.307.56q.153.28.152.603c0 .364-.159.71-.432.948l-.483.42.306.56q.153.28.153.602c0 .494-.292.94-.742 1.143H8.606v-6.334L10.8 4.303a.97.97 0 0 1 .931-.712.784.784 0 0 1 .788.82l-.212 4.378h6.936c.393.24.636.646.636 1.067 0 .365-.16.709-.433.95"
              />
            </g>
          </svg>
        )}
        {showCommentBtn && (
          <svg width={24} height={24}>
            <defs>
              <clipPath id="prefix1oMnROEiCxUvz8SRDbPLja">
                <rect width="24" height="24" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefix1oMnROEiCxUvz8SRDbPLja)">
              <path
                fill={color}
                d="M7.455 12a.91.91 0 1 0 1.818 0 .91.91 0 0 0-1.818 0m3.636 0a.91.91 0 1 0 1.818 0 .91.91 0 0 0-1.818 0m3.636 0a.91.91 0 1 0 1.819 0 .91.91 0 0 0-1.819 0m6.496-3.875a10 10 0 0 0-5.348-5.348A10 10 0 0 0 12 2h-.045A9.976 9.976 0 0 0 2 12.047a10 10 0 0 0 1.072 4.462v3.393c0 .567.46 1.027 1.026 1.027h3.395A10 10 0 0 0 11.955 22h.047c1.337 0 2.634-.259 3.855-.766a9.9 9.9 0 0 0 3.188-2.125A9.98 9.98 0 0 0 22 12.044a10 10 0 0 0-.777-3.919m-3.462 9.686a8.14 8.14 0 0 1-5.763 2.366h-.037a8.2 8.2 0 0 1-3.807-.956l-.184-.1H4.874v-3.095l-.1-.185a8.2 8.2 0 0 1-.956-3.806 8.13 8.13 0 0 1 2.366-5.8 8.12 8.12 0 0 1 5.779-2.417H12a8.14 8.14 0 0 1 5.787 2.395 8.151 8.151 0 0 1 2.395 5.822 8.15 8.15 0 0 1-2.421 5.776"
              />
            </g>
          </svg>
        )}
        {showShare && (
          <svg width={24} height={24}>
            <defs>
              <clipPath id="prefixYs5Na4Z3c5KFXb-v4bb90a">
                <rect width="24" height="24" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixYs5Na4Z3c5KFXb-v4bb90a)">
              <path
                fill={color}
                d="M12.108 2.91c.108 0 .213.04.294.113l8.545 7.774c.164.15.189.396.067.575l-.036.047q-.01.012-8.577 7.806a.436.436 0 0 1-.619-.031.44.44 0 0 1-.113-.296v-4.51q-.61.017-1.197.115l-.117.02c-3.236.591-5.836 2.465-6.701 5.614l-.066-.143c-.256-.58-.679-1.773-.679-2.963 0-4.965 3.884-9.016 8.76-9.246V3.35a.44.44 0 0 1 .44-.44zm1.166 3.076v3.329l-1.529.072c-3.52.166-6.401 2.744-7.08 6.115 1.41-1.292 3.265-2.166 5.414-2.558l.128-.023q.707-.117 1.422-.136l1.645-.042v3.52l5.647-5.14z"
              />
            </g>
          </svg>
        )}
        {showSearch && (
          <svg width={24} height={24}>
            <defs>
              <clipPath id="prefixTmLVwmyWPJM51_wlhXipVa">
                <rect width="24" height="24" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixTmLVwmyWPJM51_wlhXipVa)">
              <path
                fill={color}
                fillRule="evenodd"
                d="M10.375 17.853a7 7 0 1 0 0-14 7 7 0 0 0 0 14M13.557 7.67q1.318 1.318 1.318 3.182t-1.318 3.182-3.182 1.318-3.182-1.318-1.318-3.182T7.193 7.67t3.182-1.318 3.182 1.318m4.934 12.11-.013-.013-1.5-1.544a1.25 1.25 0 0 1 1.78-1.755l.014.013 1.5 1.544a1.25 1.25 0 0 1-1.78 1.755"
              />
            </g>
          </svg>
        )}
        <svg width={24} height={24}>
          <defs>
            <clipPath id="prefixYUdj1ELPmi_ISJjb1K3Ava">
              <rect width="24" height="24" rx="0" />
            </clipPath>
          </defs>
          <g clipPath="url(#prefixYUdj1ELPmi_ISJjb1K3Ava)">
            <path
              fill={color}
              d="M17.017 3c.306 0 .593.136.784.366l.076.104 4.97 7.846c.168.267.198.593.087.883l-.056.121-5.011 9.155a1.01 1.01 0 0 1-.77.518l-.123.007H7.026c-.331 0-.639-.16-.828-.422l-.065-.103-5.011-9.155a.99.99 0 0 1-.032-.887l.064-.117L6.123 3.47c.162-.256.431-.424.73-.462L6.984 3zm-.452 2h-9.13L2.87 11.943 7.435 20h9.13l4.564-8.057zM12 8.5c2.24 0 4.058 1.79 4.058 4s-1.817 4-4.058 4-4.058-1.79-4.058-4 1.817-4 4.058-4m0 2c-1.12 0-2.029.895-2.029 2s.909 2 2.029 2 2.029-.895 2.029-2-.909-2-2.029-2"
            />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default WButtonsREA;
